export default __webpack_public_path__ + "9d4c8d117d6384948ce0c27105d23857.png";